export default __webpack_public_path__ + "static/food-cutting-app-store-2-9df3bff1bb4332a3c65c216c710a9372.svg";